import HBIcon from "@/components/HBIcon";
import { PinEditorModal } from "@/components/PinEditor";
import { EVENT } from "@/constants/event";
import { Button } from "antd";
import { useCallback } from "react";
import styles from "./index.module.less";

/**
 * 编辑按钮
 * */
export default function PinEdit({ pin, onUpdatePin }) {
  const onEdit = useCallback(() => {
    PinEditorModal.open({
      pinId: pin?.pin_id,
      onOk: (data: IPin) => onUpdatePin({ ...pin, ...data, user: pin.user }),
      onDelete: () => {
        window.dispatchEvent(
          new CustomEvent(EVENT.DELETE_PIN, { detail: pin.pin_id })
        );
      },
    });
  }, [onUpdatePin, pin]);

  return (
    <Button
      className={styles.edit}
      onClick={onEdit}
      data-gd-click="button_click"
      data-board-id={pin?.board_id}
      data-content-id={pin?.pin_id}
      data-button-name="编辑"
      data-file-id={pin?.file_id}
      data-ext={JSON.stringify(pin?.ext)}
      data-tooltip="编辑"
      data-tooltip-position="bottom"
    >
      <HBIcon type="ic_edit" />
    </Button>
  );
}
